import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

// eslint-disable-next-line
export interface RootState { }

export default new Vuex.Store<RootState>({});
